import { Controller } from "@hotwired/stimulus";
import { initializeLottieAnimations } from "frontend/javascript/lib/lottie.js";

export default class extends Controller {
  static targets = ["lottie"];

  connect() {
    this.lottieCleanup = initializeLottieAnimations(this.lottieTargets, "SplitPane");
  }

  disconnect() {
    this.lottieCleanup?.();
  }
}

